import lrt from "../../assets/images/lrt.png";
import delfi from "../../assets/images/delfi.png";
import tv3lt from "../../assets/images/tv3lt.png";
import image1 from "../../assets/images/media/image-1.jpg";
import image2 from "../../assets/images/media/image-2.jpg";
import image3 from "../../assets/images/media/image-3.jpg";

export const MEDIA_VALUES: {
  id: number;
  link: string;
  label: string;
  date: string;
  img_src: string;
  main_img?: string;
}[] = [
  {
    id: 1,
    link: "https://www.lrt.lt/naujienos/laisvalaikis/13/2370593/genetikas-galima-mirties-data-imanoma-apskaiciuoti-pristabdyti-senejima-taip-pat",
    label:
      "Genetikas: galimą mirties datą įmanoma apskaičiuoti, pristabdyti senėjimą - taip pat",
    date: "2024.09.27",
    img_src: lrt,
    main_img: image1,
  },
  {
    id: 2,
    link: "https://www.delfi.lt/sveikata/zinoti-sveika/ivardijo-maisto-papilda-kuris-ypac-vertingas-pakankama-koncentracija-sumazino-rizika-susirgti-net-19-skirtingu-onkologiniu-ligu-120066151",
    label:
      "Įvardijo maisto papildą, kuris ypač vertingas: pakankama koncentracija sumažin",
    date: "2024.11.24",
    img_src: delfi,
    main_img: image2,
  },
  {
    id: 3,
    link: "https://www.tv3.lt/naujiena/lietuva/pase-30-ies-bet-kuno-amzius-kaip-44-eriu-genetikas-pasake-kaip-imanoma-stabdyti-senejima-n1416041",
    label:
      "Pase – 30-ies, bet kūno amžius – kaip 44-erių: genetikas pasakė, kaip įmanoma stabdyti senėjimą",
    date: "2025.05.03",
    img_src: tv3lt,
    main_img: image3,
  },
];
